(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ph-quiz-welcome"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ph-quiz-welcome')) {
    customElements.define('ph-quiz-welcome', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const incoming = new URLSearchParams(location.search);
        const fromQuiz = incoming.get('quiz') === 'completed' || incoming.get('quiz_source') === 'quiz_funnel_v2';
        if (!fromQuiz && !window.Shopify?.designMode) return;
        let result;
        try { result = JSON.parse(sessionStorage.getItem('phq-progress-v2')); } catch (error) {}
        const fresh = result?.v === 2 && result.complete === true && Number.isFinite(result.saved) && Date.now() >= result.saved && Date.now() - result.saved < 1800000;
        const messages = {
          '1': 'Your focus: more control and lasting stamina.',
          '2': 'Your focus: stronger performance and renewed confidence.',
          '3': 'Your focus: staying power and lasting confidence.',
          '4': 'Your focus: more drive, desire and energy.',
          '5': 'Your focus: drive, stamina and overall performance.',
          '6': 'Your focus: maintaining your peak performance.'
        };
        const message = fresh && messages[result.answers?.concern?.[0]];
        const focus = this.querySelector('[data-phqw-focus]');
        if (message && focus) { focus.textContent = message; focus.hidden = false; }
        this.hidden = false;
        this.querySelector('[data-phqw-reviews]')?.addEventListener('click', event => {
          const reviews = document.querySelector('.ph-review-band, [id*="testimonial_grid"], #judgeme_product_reviews, .jdgm-review-widget');
          if (!reviews) { event.preventDefault(); return; }
          event.preventDefault();
          reviews.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'start'});
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["primal-product-intro"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ph-product-intro')) {
    customElements.define('ph-product-intro', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        if (!this.querySelector('[data-phi-reviews]')) {
          requestAnimationFrame(() => {
            if (this.isConnected) this.connectedCallback();
          });
          return;
        }

        this.initialized = true;

        this.querySelector('[data-phi-reviews]').addEventListener(
          'click',
          event => {
            let target;

            try {
              target = document.querySelector(this.dataset.reviewTarget);
            } catch (error) {}

            target ||= document.querySelector(
              '.ph-review-band, [data-ph-rail="reviews"]'
            );

            if (!target) return;

            event.preventDefault();

            if (!target.id) {
              target.id = 'primalhercules-reviews';
            }

            const header = document.querySelector('sticky-header');

            target.style.scrollMarginTop =
              `${(header?.getBoundingClientRect().height || 80) + 16}px`;

            target.scrollIntoView({
              behavior: matchMedia(
                '(prefers-reduced-motion: reduce)'
              ).matches ? 'auto' : 'smooth',
              block: 'start'
            });

            if (!target.hasAttribute('tabindex')) {
              target.setAttribute('tabindex', '-1');
            }

            target.focus({ preventScroll: true });
          }
        );

        const dialog = this.querySelector('dialog');

        if (dialog) {
          this.querySelector('[data-phi-facts]').addEventListener(
            'click',
            () => dialog.showModal()
          );

          this.querySelector('[data-phi-close]').addEventListener(
            'click',
            () => dialog.close()
          );

          dialog.addEventListener('click', event => {
            const box = dialog.getBoundingClientRect();

            if (
              event.target === dialog &&
              (
                event.clientX < box.left ||
                event.clientX > box.right ||
                event.clientY < box.top ||
                event.clientY > box.bottom
              )
            ) {
              dialog.close();
            }
          });
        }

        if (
          this.dataset.autoPlace === 'true' &&
          !window.Shopify?.designMode
        ) {
          const wrapper = this.closest('.shopify-section');

          const place = () => {
            let bundle;

            try {
              bundle = document.querySelector(this.dataset.bundleTarget);
            } catch (error) {
              return false;
            }

            if (
              !bundle ||
              !wrapper ||
              wrapper.contains(bundle) ||
              bundle.contains(wrapper)
            ) {
              return false;
            }

            bundle.insertAdjacentElement('beforebegin', wrapper);
            return true;
          };

          if (!place()) {
            this.placementObserver = new MutationObserver(() => {
              if (place()) {
                this.placementObserver.disconnect();
                clearTimeout(this.placementTimeout);
              }
            });

            this.placementObserver.observe(
              document.querySelector('main') || document.body,
              {
                childList: true,
                subtree: true
              }
            );

            this.placementTimeout = setTimeout(() => {
              this.placementObserver.disconnect();
            }, 15000);
          }
        }
      }

      disconnectedCallback() {
        queueMicrotask(() => {
          if (!this.isConnected) {
            this.placementObserver?.disconnect();
            clearTimeout(this.placementTimeout);
            this.querySelector('dialog[open]')?.close();
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["primal-under-cart"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ph-under-cart')) {
    customElements.define('ph-under-cart', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        const rows = [...this.querySelectorAll('details')];

        rows.forEach(row => {
          row.addEventListener('toggle', () => {
            if (row.open) {
              rows.forEach(other => {
                if (other !== row) other.open = false;
              });
            }
          });
        });

        const videos = [...this.querySelectorAll('video')];

        videos.forEach(video => {
          const media = video.closest('.phuc-media');
          const button = media.querySelector('.phuc-play');

          button.addEventListener('click', () => {
            video.play().catch(() => {
              media.classList.add('phuc-started');
              video.focus();
            });
          });

          video.addEventListener('play', () => {
            document.querySelectorAll('ph-under-cart video').forEach(other => {
              if (other !== video) other.pause();
            });

            media.classList.add('phuc-started');
          });

          video.addEventListener('ended', () => {
            media.classList.remove('phuc-started');
          });
        });

        const rail = this.querySelector('.phuc-videos');

        this.querySelectorAll('[data-direction]').forEach(button => {
          button.addEventListener('click', () => {
            rail.scrollBy({
              left: Number(button.dataset.direction) * rail.clientWidth,
              behavior: matchMedia('(prefers-reduced-motion: reduce)').matches
                ? 'auto'
                : 'smooth'
            });
          });
        });

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) entry.target.pause();
            });
          });

          videos.forEach(video => this.observer.observe(video));
        }

        if (this.dataset.place === 'true' && !window.Shopify?.designMode) {
          const wrapper = this.closest('.shopify-section');
          let target;

          try {
            if (this.dataset.target.trim()) {
              target = document.querySelector(this.dataset.target);
            } else {
              const button = document.querySelector(
                'main [id^="ProductSubmitButton-"], main form[action*="/cart/add"] [name="add"]'
              );

              const form = button?.closest('form');
              target = form?.closest('product-form') || form;
            }
          } catch (error) {
            target = null;
          }

          if (
            wrapper &&
            target &&
            !wrapper.contains(target) &&
            !target.contains(wrapper)
          ) {
            queueMicrotask(() => {
              target.insertAdjacentElement('afterend', wrapper);
            });
          }
        }
      }

      disconnectedCallback() {
        queueMicrotask(() => {
          if (!this.isConnected) {
            this.observer?.disconnect();

            this.querySelectorAll('video').forEach(video => {
              video.pause();
            });
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
